import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { AppConfigService } from '../../services/app-config.service';
import { ReportService } from '../../services/report.service';
import { WeatherForecastService } from '../../services/weather-forecast.service';

@Component({
  selector: 'app-state-list',
  templateUrl: './state-list.component.html',
  styleUrls: ['./state-list.component.scss']
})
export class StateListComponent implements OnInit {
  navSwiper;
  swiper;
  currentDatetime;
  stateList;
  dataList;
  currentMonth;
  currentYear;
  prevMonth;
  prevMonthYear;
  constructor(
    private reportService: ReportService,
    private weatherService: WeatherForecastService,
    public appConfig: AppConfigService,
  ) { }

  ngOnInit(): void {
    this.initData();
    setInterval(() => { this.currentDatetime = Date.now() }, 1000);
    setInterval(() => { this.initData() }, 1 * 60 * 60 * 1000); //  one hour load once
  }

  initData() {
    const now = moment();
    const currentYear = now.year();
    const currentMonth = now.month();
    const prevMonth = moment([currentYear, currentMonth]).subtract(1, 'months').month();
    const prevMonthYear = moment([currentYear, currentMonth]).subtract(1, 'months').year();
    this.currentMonth = now.format('MMM');
    this.currentYear = now.format('yyyy');
    this.prevMonth = moment([currentYear, currentMonth]).subtract(1, 'months').format('MMM');
    this.prevMonthYear = moment([currentYear, currentMonth]).subtract(1, 'months').format('yyyy');
    this.stateList = this.appConfig.stateList;
    this.reportService.getReportSummaryByStates(currentYear, currentMonth + 1).subscribe(reportResp => {
      this.dataList = reportResp.data.result;
      console.log(`this.dataList >> ${JSON.stringify(this.dataList)}`);
      this.stateList = this.appConfig.stateList;
      for (const state of this.stateList) {
        const findCurrMonthStateData = this.dataList.find(d => d.stateName.toUpperCase() === state.name
          && d.month === currentMonth + 1 && d.year === currentYear);
        const findPrevMonthStateData = this.dataList.find(d => d.stateName.toUpperCase() === state.name
          && d.month === prevMonth + 1 && d.year === prevMonthYear);
        if (findCurrMonthStateData) {
          state.currMonthYield = findCurrMonthStateData.yield;
          state.currMonthCapacity = findCurrMonthStateData.capacity;
        }
        if (findPrevMonthStateData) {
          state.prevMonthYield = findPrevMonthStateData.yield;
          state.prevMonthCapacity = findPrevMonthStateData.capacity;
        }

        this.weatherService.getWeatherForecast(state.latitude, state.longitude).subscribe(resp => {
          const currentWeather = resp;
          console.log(`resp >> ${JSON.stringify(resp)}`);
          const weather = currentWeather.weather[0];
          state.weather = weather.main;
          state.temperature = currentWeather.main.temp.toFixed(0);
          if (weather.id === 801) {
            state.weatherIcon = 'assets/img/cloudy-sun.png';
          } else {
            const findWeather = this.weatherService.WeatherType.find(w => w.name === state.weather);
            if (findWeather) {
              state.weatherIcon = findWeather.img;
            }
          }
        })
      }
    });
  }

  onNavSwiperInit(swiper) {
    this.navSwiper = swiper;
  }

  onSwiper(swiper) {
    this.swiper = swiper;
  }

}
